import { useState } from 'react';

const TAG_COLORS = {
  dog:    { border: 'rgba(59,130,246,0.8)', bg: 'rgba(59,130,246,0.15)', text: '#3b82f6', label: 'bg-blue-500' },
  person: { border: 'rgba(239,68,68,0.8)',  bg: 'rgba(239,68,68,0.15)',  text: '#ef4444', label: 'bg-red-500' },
  face:   { border: 'rgba(34,197,94,0.8)',  bg: 'rgba(34,197,94,0.15)',  text: '#22c55e', label: 'bg-green-500' },
  horse:  { border: 'rgba(168,85,247,0.8)', bg: 'rgba(168,85,247,0.15)', text: '#a855f7', label: 'bg-purple-500' },
};

export default function SportAIOverlay({
  aiTags = [],
  imageWidth = 0,
  imageHeight = 0,
  displayWidth = 0,
  displayHeight = 0,
  showLabels = true,
}) {
  if (!aiTags.length || !imageWidth || !displayWidth) return null;

  const scaleX = displayWidth / imageWidth;
  const scaleY = displayHeight / imageHeight;

  return (
    <div className="absolute inset-0 pointer-events-none">
      {aiTags.map((tag, idx) => {
        const bbox = tag.bbox;
        if (!bbox || bbox.length < 4) return null;

        const [bx, by, bw, bh] = bbox;
        const colors = TAG_COLORS[tag.type] || TAG_COLORS.person;

        const left = bx * scaleX;
        const top = by * scaleY;
        const width = bw * scaleX;
        const height = bh * scaleY;

        return (
          <div
            key={idx}
            className="absolute"
            style={{
              left: `${left}px`,
              top: `${top}px`,
              width: `${width}px`,
              height: `${height}px`,
              border: `2px solid ${colors.border}`,
              backgroundColor: colors.bg,
              borderRadius: '4px',
            }}
          >
            {showLabels && (
              <span
                className={`absolute -top-5 left-0 ${colors.label} text-white text-[10px] px-1 py-0.5 rounded whitespace-nowrap`}
              >
                {tag.dog_name || tag.competitor_name || tag.type}
                {tag.confidence ? ` ${Math.round(tag.confidence * 100)}%` : ''}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
